import { useSearchParams } from 'react-router-dom';

import {
  DialogAdditionalParamKey,
  DialogKey,
} from 'components/navigation/WithDialogs';

export const useDialogParam = (
  dialogKey: DialogKey | DialogAdditionalParamKey
) => {
  const [searchParams] = useSearchParams();
  return searchParams.get(dialogKey);
};
